import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import Card from '../../common/Card';
import FormInput from '../../common/FormInput';
import Button from '../../common/Button';
import ErrorMessage from '../../common/ErrorMessage';
import './styles.css';

/**
 * 登入組件
 * 用於使用者登入
 * 
 * @param {Object} props 組件屬性
 * @param {Function} props.onLogin 登入成功回調函數
 * @returns {JSX.Element} 登入組件
 */
function Login({ onLogin }) {
    const navigate = useNavigate();

    // 使用自定義Hook
    const { login, loading, error, isAuthenticated } = useAuth();

    // 表單狀態
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [formErrors, setFormErrors] = useState({
        username: '',
        password: ''
    });

    // 追蹤登入成功狀態
    const [loginSuccess, setLoginSuccess] = useState(false);

    // 如果已經登入或登入成功，重定向到首頁
    useEffect(() => {
        if (isAuthenticated || loginSuccess) {
            navigate('/');
        }
    }, [isAuthenticated, loginSuccess, navigate]);

    // 表單驗證
    const validateForm = () => {
        let valid = true;
        const newErrors = {
            username: '',
            password: ''
        };

        if (!username.trim()) {
            newErrors.username = '請輸入使用者名稱';
            valid = false;
        }

        if (!password) {
            newErrors.password = '請輸入密碼';
            valid = false;
        }

        setFormErrors(newErrors);
        return valid;
    };

    // 處理表單提交
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        const success = await login(username, password);

        if (success) {
            if (onLogin) {
                const token = localStorage.getItem('token');
                const user = JSON.parse(localStorage.getItem('user') || 'null');
                onLogin(token, user);
            }

            setLoginSuccess(true);

            navigate('/');
        }
    };

    return (
        <div className="login-container">
            <div className="login-logo-container">
                <img src="/icon.png" alt="Logo" className="login-logo" />
                <h1 className="login-title">保養單管理系統</h1>
            </div>

            <Card className="login-card">
                <h2 className="login-card-title">登入</h2>

                {error && (
                    <ErrorMessage message={error} />
                )}

                <form onSubmit={handleSubmit} className="login-form">
                    <FormInput
                        id="username"
                        label="使用者名稱"
                        type="text"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        placeholder="請輸入使用者名稱"
                        required
                        error={formErrors.username}
                    />

                    <FormInput
                        id="password"
                        label="密碼"
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="請輸入密碼"
                        required
                        error={formErrors.password}
                    />

                    <Button
                        type="submit"
                        variant="primary"
                        fullWidth
                        disabled={loading}
                    >
                        {loading ? '登入中...' : '登入'}
                    </Button>
                </form>

                <div className="login-footer">
                    <p>© {new Date().getFullYear()} 保養單管理系統</p>
                </div>
            </Card>
        </div>
    );
}

export default Login; 